module.exports = __webpack_public_path__ + "img/Close-1.14a562bb.svg";